import './GroupList.scss';
import gql from 'graphql-tag';
import { timeSince } from '../../../helpers/date';
import icons from '../../../shared/assets/icons/redesign';
import {
  communityGroupRecentActivityDate,
  isCommunityGroupMember,
  openCommunityPage
} from '../../../helpers/user';

const { Dot } = icons;

export default function CourseList({ useQuery, list = '', user, config }) {
  const { data = {} } = useQuery(
    gql`
      query {
        userGroups {
          xuid
          uri
          displayName
          imageUrl
          members {
            username
          }
          topics {
            xuid
            createdAt
            events {
              xuid
              createdAt
              updatedAt
            }
          }
        }
      }
    `,
    { ssr: false }
  );

  const groupList = (data?.userGroups || []).filter(({ xuid, uri }) =>
    list
      .slice(1, -1)
      .split(', ')
      .find((item) => item === xuid)
  );

  return (
    <ul className="groupList">
      {groupList.map((group) => {
        const isMember = isCommunityGroupMember(group, user);

        const recentActivityDate = communityGroupRecentActivityDate(group);

        return (
          <li key={group.xuid} className="groupList-item">
            <div className="groupList-item-data">
              <img
                className="groupList-item-img"
                alt="group-image"
                src={group.imageUrl}
              />

              <div className="groupList-item-meta">
                {recentActivityDate && (
                  <span className="groupList-item-last-update">
                    <Dot /> {timeSince(recentActivityDate)}
                  </span>
                )}
                <p className="groupList-item-name">{group.displayName}</p>
                <span className="groupList-item-member-count">
                  {group.members.length}{' '}
                  {group.members.length === 1 ? 'lid' : 'leden'}
                </span>
              </div>
            </div>

            <button
              onClick={() => openCommunityPage(user, group, config)}
              className="groupList-item-btn cursor-pointer"
            >
              {isMember ? 'Bekijken' : 'Deelnemen'}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
